/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

import {hasNativeDeclarativeShadowRoots} from './_implementation/feature_detect.js';
import {hydrateShadowRoots} from './_implementation/default_implementation.js';

export {hasNativeDeclarativeShadowRoots, hydrateShadowRoots};
